__turbopack_context__.v({
  "AverageMarker": "NXhByq_AverageMarker",
  "RatingDisplay": "NXhByq_RatingDisplay",
});
